import {
  ListSubheader,
  Select,
  Stack,
  SvgIcon,
  Typography
} from '@mui/material'
import { Map01 } from '@untitled-ui/icons-react'
import { Option } from 'ui-components/components/atoms/Option'
import { BootstrapInput } from 'ui-components/components/molecules/Visualization/BootstrapInput'

export const Aggregate = (props) => {
  const { value, onChange, options = [] } = props
  return (
    <Stack spacing={1}>
      <Select
        value={value}
        onChange={onChange}
        input={<BootstrapInput />}
      >
        <ListSubheader>Aggregate by</ListSubheader>

        {options.map((option) => (
          <Option
            key={option.name}
            value={option.name}
          >
            <Stack
              direction='row'
              flex={1}
              gap={2}
              alignItems='center'
            >
              <SvgIcon>
                <Map01 />
              </SvgIcon>
              <Typography variant='body2'>
                {option.name === 'count' ? 'Count' : option.name}
              </Typography>
            </Stack>
          </Option>
        ))}
      </Select>
    </Stack>
  )
}
